import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { useEffect, useState } from "react";
import ShowSnackBar from "../components/snackBar";
import "../css/wb_manage_block_number.css";

import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import "../css/wb_manage_groups.css";
import { manageUser, rechargeWallet } from "../services/manageUser";

const ManageUser = () => {
    const [loading, setLoading] = useState(false);
    const [remark, setRemark] = useState("");
    const [recharging, setRecharging] = useState(false);

    const [snackBar, setSnackBar] = useState({
        open: false,
        severity: true,
        message: "",
    });
    // const moneyAmount = [5000, 10000, 30000, 50000]
    const moneyAmount = [100, 5000, 10000, 30000,]
    const [rows, setRows] = useState([]);
    const userId = JSON.parse(localStorage.getItem('user-cred'))?.user?.userId || '';


    // MODAL STATES
    const [openModal, setOpenModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [amount, setAmount] = useState(0);

    const handleCloseSnackBar = () => {
        setSnackBar((prevState) => ({ ...prevState, open: false }));
    };


    // MOVE LOGIN USER TO TOP
    const moveToFront = (arr, id) => {
        const index = arr.findIndex(u => u.dealerCode == id);
        if (index <= 0) return arr;

        const item = arr[index];
        const rest = arr.filter((_, i) => i !== index);
        return [item, ...rest];
    };


    // FETCH USERS DATA
    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await manageUser(setSnackBar);
            if (response?.success) {
                const newRows = moveToFront(response.data, userId);
                setRows(newRows || []);
            }
        } catch (error) {
            setSnackBar({
                open: true,
                severity: false,
                message: "Failed to fetch users data",
            });
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchUsers();
    }, []);


    const columns = [
        { id: "dealerCode", label: "Dealer Code", minWidth: 120 },
        { id: "userName", label: "Dealer Name", minWidth: 170 },
        { id: "userBalance", label: "Amount (₹)", minWidth: 100, align: 'right' },
        { id: "Action", label: "Add Money", minWidth: 100, align: 'right' },
    ];


    // MODAL HANDLERS
    const handleOpenModal = (user) => {
        setSelectedUser(user);
        setAmount(0);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedUser(null);
    };

    const subtotal = Number(amount) || 0;
    const gst = subtotal * 0.18;
    const grandTotal = subtotal + gst;

    const handleRecharge = async () => {
        if (!remark.trim()) {
            setSnackBar({
                open: true,
                severity: false,
                message: "Remark is required",
            });
            return;
        }

        setRecharging(true);
        try {
            const payload = {
                amount: subtotal,
                dealerCode: selectedUser.dealerCode,
                remark: remark
            }

            const response = await rechargeWallet(payload)
            if (response?.success) {
                window.location = response?.redirectUrl;
            }
        }
        catch (e) {
            setSnackBar({
                open: true,
                severity: false,
                message: `Recharge failed.`,
            });
            setRecharging(false);
        }

    };

    return (
        <>
            <div className="Block_number_contian">
                <h4 className="Head_title AdminSearchContain headTitle">Manage Networks</h4>

                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer sx={{ maxHeight: '70dvh', pb: 2 }} className="table_contain">
                        <Table stickyHeader aria-label="sticky table" className="Table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column, index) => (
                                        <TableCell
                                            key={index}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {loading ? (
                                    <TableRow>
                                        <TableCell colSpan={columns.length} align="center">
                                            Loading...
                                        </TableCell>
                                    </TableRow>
                                ) : rows.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={columns.length} align="center">
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    rows.map((row, index) => (
                                        <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                            {columns.map((column) => {
                                                let value = row[column.id];

                                                if (column.id === "userBalance") {
                                                    return (
                                                        <TableCell key={column.id} align={column.align || 'left'}>
                                                            {typeof value === "number"
                                                                ? value.toLocaleString()
                                                                : value || '-'}
                                                        </TableCell>
                                                    );
                                                }
                                                if (column.id === "Action") {
                                                    return (
                                                        <TableCell key={column.id} align={column.align || 'left'}>
                                                            <button
                                                                className="add_money"
                                                                onClick={() => handleOpenModal(row)}
                                                            >
                                                                +
                                                            </button>
                                                        </TableCell>
                                                    );
                                                }

                                                return (
                                                    <TableCell key={column.id} align={column.align || 'left'}>
                                                        {value || '-'}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>

            {/* Recharge Modal */}
            <Dialog open={openModal} onClose={handleCloseModal} maxWidth="sm" minWidth="300px" className="add_money_modal">
                <DialogTitle sx={{ pb: 1 }}>Add Money</DialogTitle>
                <DialogContent>
                    <p style={{ opacity: 0.8 }}>Dealer: {selectedUser?.userName} ({selectedUser?.dealerCode})</p>

                    <Typography variant="h6" sx={{ width: "100%", fontWeight: "bold", mt: 2, mb: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        ₹ {amount}
                        <button className="money-button" onClick={() => setAmount(0)} disabled={recharging}>Clear</button>
                    </Typography>

                    <div className="money-button-group">
                        {moneyAmount.map((item, index) => (
                            <button className="money-button" key={index} onClick={() => setAmount((prev) => prev + item)} disabled={recharging} >
                                + {item}
                            </button>
                        ))}
                    </div>

                    <div style={{ marginTop: "16px", borderTop: "1px solid #434343", marginTop: "16px" }}>
                        <Typography sx={{ mt: 2, fontSize: "12px", color: "black" }} >Subtotal: ₹{subtotal.toFixed(2)}</Typography>
                        <Typography sx={{ mt: 0, fontSize: "12px", color: "black" }} >GST (18%): ₹{gst.toFixed(2)}</Typography>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mt: 1 }}>
                            Grand Total: ₹{grandTotal.toFixed(2)}
                        </Typography>
                    </div>

                    <textarea className="remarks-textarea" name="remarks" id="remarks" placeholder="Add remarks here..." value={remark} onChange={(e) => setRemark(e.target.value)} disabled={recharging}></textarea>

                </DialogContent>
                <DialogActions>
                    <button className="cancel-button" onClick={handleCloseModal} disabled={recharging}>Cancel</button >
                    <button className="money-button" onClick={handleRecharge} disabled={recharging}>
                        {recharging ? 'Processing...' : 'Recharge'}
                    </button >
                </DialogActions>
            </Dialog>

            <ShowSnackBar
                open={snackBar.open}
                severity={snackBar.severity}
                autoHideDuration={3000}
                message={snackBar.message}
                onClose={handleCloseSnackBar}
            />
        </>
    );
};

export default ManageUser;